// Day js
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
// Translation
import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next, useTranslation } from "react-i18next";
// React
import { useEffect } from "react";
// React router dom
import { Route, Routes, useLocation, useNavigationType } from "react-router-dom";
import { toPublicUrl } from "./services/PublicUrl";
// Pages
import Home from "./pages/Home/Home";
import InProgress from "./pages/InProgress/InProgress";
import AllDocuments from './pages/AllDocuments/AllDocuments';
import BundleDocuments from './pages/BundleDocuments/BundleDocuments';
import DocumentViewerPage from "./pages/DocumentViewer/DocumentViewerPage";
import Error from "./pages/Error/Error";
import QRCodeScanner from './pages/QRCodeScanner/QRCodeScanner';
import ImplementationGuidePage from "./pages/ImplementationGuide/ImplementationGuidePage";

require('dayjs/locale/fr');

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['fr', 'en'],
    backend: {
      loadPath: toPublicUrl('/locales/{{lng}}/{{ns}}.json'),
    },
  })

dayjs.extend(relativeTime);
dayjs.locale(i18n.language);

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  const { t } = useTranslation();

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
      case "/Papyrus":
      case "/Home":
      case "/Papyrus/Home":
        title = t("title.home");
        metaDescription = "";
        break;
      case "/InProgress":
        title = t("title.inprogress.comingsoon");
        metaDescription = "";
        break;
      case "/AllDocuments":
        title = t("title.alldocuments");
        metaDescription = "";
        break;
      case "/BundleDocumentViewer":
        title = t("title.bundledocumentviewer");
        metaDescription = "";
        break;
      case "/BundleDocuments":
        title = t("title.bundledocument");
        metaDescription = "";
        break;
      case "/Reader":
        title = t("navbar.items.reader");
        metaDescription = "";
        break;
      case "/ImplementationGuide":
        title = t("title.implementationguide");
        metaDescription = "";
        break;
      case "/Error":
        title = t("title.error.oops");
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag: HTMLMetaElement | null = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname, t]);

  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="/" element={<Home />} />
      <Route path="/Home" element={<Home />} />
      <Route path="/Papyrus" element={<Home />} />
      <Route path="/Papyrus/Home" element={<Home />} />
      <Route path="/InProgress" element={<InProgress />} />
      <Route path="/AllDocuments" element={<AllDocuments />} />
      <Route path="/DocumentViewer/:documentReferenceId/:contentIndex" element={<DocumentViewerPage />} />
      <Route path="/BundleDocuments" element={<BundleDocuments />} />
      <Route path="/BundleDocumentViewer" element={<BundleDocuments />} />
      <Route path="/Reader" element={<QRCodeScanner />} />
      <Route path="/BundleDocumentViewer/:documentId" element={<QRCodeScanner />} />
      <Route path="/ImplementationGuide" element={<ImplementationGuidePage />} />
      <Route path="/Error" element={<Error />} />
    </Routes>
  );
}

export default App;
